/**
 * @name BUYING
 * @constant
 * @string
 * @description Used to denote an offer to buy
 */
export const BUYING = 'buying';

/**
 * @name SELLING
 * @constant
 * @string
 * @description Used to denote an offer to sell
 */
export const SELLING = 'selling';